"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _translation = require("../_utils/translation");
var _FilteredList = _interopRequireDefault(require("../FilteredList"));
var _WebinarTabs = _interopRequireDefault(require("./WebinarTabs"));
var _excluded = ["translations", "defaultSpeakerImage", "anchorId"];
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _webinarCopy;
  return {
    webinarCopy: (_webinarCopy = {
      borderBottom: "2px solid ".concat(theme.palette.common.black),
      paddingBottom: theme.spacing(4),
      marginBottom: theme.spacing(5)
    }, (0, _defineProperty2.default)(_webinarCopy, theme.breakpoints.up('md'), {
      marginBottom: theme.spacing(3)
    }), (0, _defineProperty2.default)(_webinarCopy, '& h2', (0, _defineProperty2.default)({
      maxWidth: '950px',
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1)
    }, theme.breakpoints.up('md'), {
      marginBottom: theme.spacing(4)
    })), (0, _defineProperty2.default)(_webinarCopy, '& p', {
      maxWidth: '950px',
      marginBottom: theme.spacing(3)
    }), (0, _defineProperty2.default)(_webinarCopy, '& :nth-child(2)', {
      marginBottom: theme.spacing(6)
    }), _webinarCopy)
  };
});
var WebinarListing = function WebinarListing(props) {
  var classes = useStyles();
  var _props$translations = props.translations,
    translations = _props$translations === void 0 ? _objectSpread({
      upcoming: 'Upcoming',
      onDemand: 'On Demand',
      session: 'Session',
      presented: 'Presented',
      language: 'Language',
      duration: 'Duration'
    }, _translation.commonListingTranslations) : _props$translations,
    defaultSpeakerImage = props.defaultSpeakerImage,
    anchorId = props.anchorId,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var translationsFilter = {
    appliedFilters: translations.appliedFilters,
    selectAllFilters: translations.selectAllFilters,
    changeFilterCriteria: translations.changeFilterCriteria,
    deselectAllFilters: translations.deselectAllFilters,
    done: translations.done,
    filters: translations.filters,
    invalidDate: translations.invalidDate,
    invalidEndDate: translations.invalidEndDate,
    invalidStartDate: translations.invalidStartDate,
    noSearchResults: translations.noSearchResults,
    uncheckAll: translations.uncheckAll
  };
  return __jsx(_react.default.Fragment, null, __jsx("div", {
    className: classes.webinarCopy
  }), __jsx(_FilteredList.default, (0, _extends2.default)({
    translations: translationsFilter,
    anchorId: anchorId
  }, otherProps, {
    dateRangeFacet: {
      start: {
        label: translations.dateRangeStart,
        itemKey: 'timestamp',
        placeholder: translations.selectDate
      },
      end: {
        label: translations.dateRangeEnd,
        itemKey: 'timestamp',
        placeholder: translations.selectDate
      },
      objectArrayKey: 'sessions'
    },
    checkboxFacets: [{
      label: translations.facetTopic,
      itemKey: 'category',
      itemType: 'array',
      checkAllControl: true
    }, {
      label: translations.facetLanguages,
      itemKey: 'language',
      itemType: 'array',
      checkAllControl: true
    }],
    dateFormat: 'MMM dd, yyyy',
    ItemListComponent: _WebinarTabs.default,
    itemListComponentProps: {
      learnMoreCta: translations.learnMore,
      defaultSpeakerImage: defaultSpeakerImage,
      sessionText: translations.session,
      presentedText: translations.presented,
      durationText: translations.duration,
      languageText: translations.language,
      upcomingText: translations.upcoming,
      ondemandText: translations.onDemand,
      filtersLabel: translations.filters,
      filterAndSortLabel: translations.filterAndSort,
      page: translations.page,
      pagination: translations.pagination
    },
    itemListRenderEmpty: true
  })));
};
var WebinarListingEditConfig = {
  emptyLabel: 'Webinar Listing',
  isEmpty: function isEmpty(props) {
    var _props$listItems;
    if (props !== null && props !== void 0 && props.listItems && (props === null || props === void 0 ? void 0 : (_props$listItems = props.listItems) === null || _props$listItems === void 0 ? void 0 : _props$listItems.length) > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/webinarlisting')(WebinarListing, WebinarListingEditConfig);
exports.default = _default;